import { useSelector } from "react-redux";
import { useGetTasksQuery } from "../../redux/features/tasks/taskApi";
import SingleTask from "./SingleTask";


export default function TaskList(){
    const {data: tasks, isLoading, isError} = useGetTasksQuery();
    const {filter, search} = useSelector(state=>state.filter) || {}

 // filter callback functions
 const searchCallback = (item)=> {
     if(search?.length > 0){
         return item.taskName.toLowerCase().includes(search.toLowerCase())
     } else {return true}
 }

    // decide what to render
    let content = null;
    if(isLoading){content=  <div>Loading....</div>}
    else if(!isLoading && isError){content=  <div>There was an error occurred</div> }
    else if(!isLoading && !isError && tasks?.length <= 0){content=  <div>task not found</div> }
    else if(!isLoading && !isError && tasks?.length > 0){
       content =  tasks.filter(searchCallback).map(task=>{
        if(filter.find(item=>item.id === task.project.id)){
            return <SingleTask key={task.id} task={task}/>
        }else{
            return undefined
        }
       })
    }

  return(
    <div className="lws-task-list">
          {content}
        </div>
  )};